import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGRNSubGRNListResponse, IGRNSubGRNListResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useGRNSubGRNListAPI = () => {
  const [subGRNCompleted, setSubGRNCompleted] = useState<IGRNSubGRNListResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (grnId: string) => {
      dispatch(
        setLoading({
          key: "isInventoryCompletedGRNListInProgress",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!grnId) {
          return;
        }

        const url = `${INVENTORY_MODULE?.GRN_SUB_GRN_LIST_API?.baseURL}${grnId}/`; // Update the URL

        const response = await axios
          .get(url, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IGRNSubGRNListResponse>) => {
            dispatch(
              setLoading({
                key: "isInventoryCompletedGRNListInProgress",
                status: false,
              }),
            );
            if (res.data.status) {
              setSubGRNCompleted(res.data.data);
            } else {
              setSubGRNCompleted([]);
            }
          })
          .catch((e) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isInventoryCompletedGRNListInProgress",
                status: false,
              }),
            );
            setSubGRNCompleted([]);
          });
        return response;
      } catch (error) {
        // Handle errors
        setSubGRNCompleted([]);
        dispatch(
          setLoading({
            key: "isInventoryCompletedGRNListInProgress",
            status: false,
          }),
        );
        if (axios.isAxiosError(error)) {
          captureError(error)
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { subGRNCompleted, execute };
};
